const productDescriptions = {
  "Desgranadoras_de_Maíz_eléctricas": {
    lines: ["Motor: Gasolina", "Voltaje: 120 y 240 voltios"]
  },
  "Desgranadoras_de_Maiz_doble_rodo": {
    lines: ["Motor: Gasolina", "Doble rodo para mayor rendimiento"]
  },
  "Aspersor_de_agua": {
    lines: ["Tamaño: 2 y 1/2 pulgada"]
  },
  "Picadora_y_Ensiladora": {
    lines: ["Modelo JF40"]
  },
  "Peletizadora": {
    lines: [
      "Voltaje: 110 o 220 voltios",
      "Energía eléctrica",
      "Capacidades: 80-100 kg/h, 90-150 kg/h y 150-200 kg/h"
    ]
  },
  "Peletizadora_Diesel": {
    lines: ["Potencias disponibles: 15HP, 25HP y 30HP"]
  },
  "Desgranadora_de_Maíz_con_motor": {
    lines: ["Motor: Gasolina", "Potencia: 7HP", "Incluye tusa"]
  },
  "Bomba_de_fumigar": {
    lines: ["Opciones en motores de 2 y 4 tiempos"]
  },
  "Motor_a_Gasolina": {
    lines: ["Potencia: 7.5HP y 15HP"]
  },
  "Sembradora_de_Maíz_con_motor": {
    lines: ["Cultivos: maíz, sorgo y ajonjolí", "Doble surco"]
  },
  "Abonda_tipo_bolsa_(2)": {
    lines: ["Incluye doble manguera"]
  },
  "Manguera_de_agua": {
    lines: ["Tamaños: 2 y 3 pulgadas"]
  },
  "Trípode_para_Aspersor_de_agua": {
    lines: ["Tamaños: 1.5 y 2 pulgadas"]
  },
  "Bomba_de_agua_de_precisión": {
    lines: ["Tamaños: 2 y 3 pulgadas"]
  },
  "Molino_de_Maíz_eléctrico": {
    lines: ["Voltaje: 110 voltios", "Especial para maíz seco"]
  },
  "Sembradoras_Manuales": {
    lines: ["Distancias: 13cm, 16cm y 20cm"]
  },
  "Taladro": {
    lines: ["Brocas de 2 y 3 pulgadas"]
  },
  "Sembradoras_de_Hortalizas_con_Motor": {
    lines: ["Surcos disponibles: 1, 3, 4 y 5 filas"]
  },
  "Bomba_de_fumigar_(2)": {
    lines: ["Capacidades especiales para fumigación continua"]
  },
  "Generador_de_Diesel": {
    lines: ["Generación confiable para trabajo en campo"]
  },
  "Motocultivador": {
    lines: ["Equipo ideal para preparación de suelo"]
  },
  "Sembradoras_de_Pilon": {
    lines: ["Siembra precisa de pilón"]
  },
  "Sembradoras_Push": {
    lines: ["Operación manual para pequeños cultivos"]
  },
  default: {
    lines: ["Consulta nuestro catálogo para más detalles del producto."]
  }
};

export default productDescriptions;
